module.exports = __webpack_public_path__ + "img/bg_8.902cc57d.png";